<template>
	<b-modal
		ref="PublicKeyModal"
		:title="title"
		:modal-class="theme"
		size="lg"
		no-close-on-backdrop
		:ok-title="submitLabel"
		@ok.prevent="save"
		@close="clean"
		@cancel="clean"
	>
		<form @submit.prevent="save" autocomplete="off" v-if="!loading">
			<div class="form-group">
				<label for="id">ID</label>
				<input
					type="text"
					id="id"
					v-model.trim="form.id"
					class="form-control"
					:disabled="!isNew"
					:class="{ 'is-invalid': isIdInvalid }"
				/>
				<div v-if="isIdInvalid" class="invalid-feedback">
					Please provide ID.
				</div>
			</div>
			<div class="form-group">
				<label for="key">Key</label>
				<textarea
					id="key"
					v-model.trim="form.key"
					class="form-control"
					:class="{ 'is-invalid': isKeyInvalid }"
				/>
				<div v-if="isKeyInvalid" class="invalid-feedback">
					Please provide key.
				</div>
			</div>
		</form>

		<div v-else>
			<Spinner />
		</div>
		<ErrorDialog ref="errDialog" />
	</b-modal>
</template>

<script>
import Spinner from '../shared/Spinner';
import PublicKeyService from '../../services/public-key';
import ErrorDialog from '../shared/ErrorDialog';
import ThemeService from "../../services/theme";

export default {
	name: 'PublicKeyDialog',
	components: {
		ErrorDialog,
		Spinner,
	},
	data() {
		return {
			id: null,
			loading: false,
			form: { id: null, key: null },
			submitted: false,
			theme: 'light'
		};
	},
	created() {
		this.theme = ThemeService.instance().getTheme() || 'light';
		this.listenForThemeChanges();
	},
	computed: {
		isNew() {
			return !this.id;
		},
		title() {
			return this.isNew ? 'Add Access Key' : 'Edit Access Key';
		},
		submitLabel() {
			return this.isNew ? 'Create' : 'Save';
		},
		isIdInvalid() {
			return this.submitted && !this.form.id;
		},
		isKeyInvalid() {
			return this.submitted && !this.form.key;
		},
		isFormInvalid() {
			return this.isIdInvalid || this.isKeyInvalid;
		},
	},
	methods: {
		async show(id) {
			this.$refs.PublicKeyModal.show();
			this.id = id;
			if (this.isNew) {
				return;
			}
			this.loading = true;
			this.form.id = this.id;
			return PublicKeyService.instance()
				.getById(this.id)
				.then(publicKey => (this.form.key = publicKey.key))
				.catch(err => this.$refs.errDialog.show(err))
				.finally(() => (this.loading = false));
		},
		async save() {
			this.submitted = true;
			if (this.isFormInvalid) {
				return;
			}
			return this.executeModification()
				.then(() => this.$refs.PublicKeyModal.hide())
				.then(() => this.$emit('saved'))
				.then(() => this.clean())
				.catch(err => this.$refs.errDialog.show(err));
		},
		async executeModification() {
			if (this.isNew) {
				return PublicKeyService.instance().create(this.form);
			} else {
				return PublicKeyService.instance().update(this.id, {
					key: this.form.key,
				});
			}
		},
		clean() {
			this.form = { id: null, key: null };
			this.submitted = false;
		},
		listenForThemeChanges: function () {
			ThemeService.instance().events.on("themechanged", () => {
				this.theme = ThemeService.instance().getTheme();
			});
		},
	},
};
</script>

<style scoped>
textarea {
	font-family: monospace;
	min-height: 24em;
}
</style>
